export const GlobalGridPreset = {
  BASE_GRID: 'base-grid',
} as const

export type GlobalGridPreset =
  typeof GlobalGridPreset[keyof typeof GlobalGridPreset]
